import { forwardRef, ReactElement } from 'react'
import { Button, ButtonProps } from '.'

export interface Props extends Omit<ButtonProps, 'leftIcon' | 'rightIcon'> {
  /** Position button to horizontally align icon with container */
  align?: 'left' | 'right'
  'aria-label': string
  icon: ReactElement
  /** Position button to vertically justify icon with container */
  justify?: 'top' | 'bottom'
}

export default forwardRef<HTMLButtonElement, Props>(
  ({ align, icon, justify, size, ...rest }, ref) => {
    return (
      <Button
        ref={ref}
        top={justify && `${justify === 'top' ? '-' : ''}4px`}
        left={align && `${align === 'left' ? '-' : ''}8px`}
        variant="ghost"
        leftIcon={icon}
        iconSpacing={0}
        px={2}
        size={size}
        {...rest}
      />
    )
  }
)
